import { render, staticRenderFns } from "./traiteSection.vue?vue&type=template&id=32f4e475&scoped=true&"
import script from "./traiteSection.vue?vue&type=script&lang=js&"
export * from "./traiteSection.vue?vue&type=script&lang=js&"
import style0 from "./traiteSection.vue?vue&type=style&index=0&id=32f4e475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4e475",
  null
  
)

export default component.exports